import { styled as styledMui, Box, Button, IconButton } from "@mui/material";

export const BarContainer = styledMui(Box)({
  display: "flex",
  alignItems: "center",
  gap: "12px",
  width: "100%",
});

export const LeftGroup = styledMui(Box)({
  display: "flex",
  alignItems: "center",
  gap: "12px",
  flexWrap: "wrap",
  flex: 1,
});

export const RightGroup = styledMui(Box)({
  display: "flex",
  alignItems: "center",
  gap: "4px",
});

export const BulkActionBtn = styledMui(Button)(({ theme }) => ({
  minWidth: "auto",
  padding: "6px 14px",
  fontSize: "13px",
  fontWeight: 600,
  borderRadius: "8px",
  textTransform: "none",
  lineHeight: 1.4,
  gap: "6px",
  border: `1px solid ${theme.palette.divider}`,
  color: theme.palette.text.primary,
  "&:hover": {
    borderColor: theme.palette.text.tertiary,
    backgroundColor: theme.palette.action.hover,
  },
  "&.Mui-disabled": {
    color: theme.palette.text.disabled,
    borderColor: theme.palette.divider,
  },
}));

export const IconActionBtn = styledMui(IconButton)(({ theme }) => ({
  width: "36px",
  height: "36px",
  borderRadius: "8px",
  color: theme.palette.text.primary,
  "&:hover": {
    backgroundColor: theme.palette.action.hover,
  },
  "&.Mui-disabled": {
    color: theme.palette.text.disabled,
  },
}));
